import { STORE_PAGE_TEMPLATES } from '@mediardex/contracts'
import { useState } from 'react'
import { MdClose } from 'react-icons/md'

interface NewPageDialogProps {
    open: boolean
    busy: boolean
    onClose: () => void
    onCreate: (templateKey: string, title: string) => void
}

/** "Nova página": escolhe um modelo e, se quiser, o título. */
export default function NewPageDialog({ open, busy, onClose, onCreate }: NewPageDialogProps) {
    const [templateKey, setTemplateKey] = useState('about')
    const [title, setTitle] = useState('')
    if (!open) return null

    return (
        <dialog className="modal modal-open z-50">
            <div className="modal-box !mx-4 !max-w-2xl !p-0">
                <div className="flex items-center justify-between border-b border-base-200 p-4">
                    <h2 className="text-lg font-bold">Nova página</h2>
                    <button type="button" className="btn btn-ghost btn-sm" onClick={onClose}>
                        <MdClose className="text-lg" />
                    </button>
                </div>
                <div className="flex flex-col gap-5 p-4">
                    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        {STORE_PAGE_TEMPLATES.map((template) => (
                            <button
                                type="button"
                                key={template.key}
                                onClick={() => setTemplateKey(template.key)}
                                className={`flex flex-col gap-1 rounded-xl border p-3 text-left transition-colors ${templateKey === template.key ? 'border-primary bg-primary/5' : 'border-base-300 hover:border-primary'}`}
                            >
                                <span className="font-semibold">{template.title}</span>
                                <span className="text-xs text-base-content/70">{template.description}</span>
                            </button>
                        ))}
                    </div>
                    <div className="flex flex-col gap-1.5">
                        <span className="text-sm font-medium">Título (opcional)</span>
                        <input
                            type="text"
                            className="input input-bordered w-full"
                            maxLength={120}
                            placeholder={STORE_PAGE_TEMPLATES.find((t) => t.key === templateKey)?.title}
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                        <span className="text-xs text-base-content/60">
                            A página nasce com um texto de exemplo para você trocar. Entra na loja ao publicar.
                        </span>
                    </div>
                    <div className="flex justify-end gap-2">
                        <button type="button" className="btn btn-sm btn-ghost" onClick={onClose}>
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            disabled={busy}
                            onClick={() => onCreate(templateKey, title.trim())}
                        >
                            {busy && <span className="loading loading-spinner loading-xs" />} Criar página
                        </button>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop" onClick={onClose} />
        </dialog>
    )
}
